import {
  Box,
  Button,
  Checkbox,
  Container,
  Grid,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { styled } from '@mui/material/styles'
import Paper from '@mui/material/Paper'
import shareicon from 'Components/images/share.svg'
import infoicon from 'Components/images/infoicon.svg'
import commenticon from 'Components/images/comment-icon.png'
import blogo from 'Components/images//blogo.png'
import attachementicon from 'Components/images/attachment.png'
import mailicon from 'Components/images/mail.png'
import SendIcon from '@mui/icons-material/Send'
import { Input } from 'Components/Input'
import SearchIcon from '@mui/icons-material/Search'
import AddIcon from '@mui/icons-material/Add'
import Tab from '@mui/material/Tab'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import { makePostRequest } from 'utils/api'
import { useSelector } from 'react-redux'
import { useParams, useSearchParams } from 'react-router-dom'
import { makeGetRequest } from 'utils/api'
import CustomButton from 'Components/CustomButton/CustomButton'
import { convertToUserDateFormate } from 'utils/helpers'
import urls from 'utils/urls'
import AttachmentIcon from '@mui/icons-material/Attachment'
// import CreateDocumentsForm from 'Components/CreateDocumentsForm'
import CommentPng from 'Components/images/comment.png'
import Avatar from '@mui/material/Avatar'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import CreateDocForm from './CreateDocForm'
import CreateMessage from './CreateMessage'
export default function MyInbox() {
  const { t } = useTranslation()
  const siteUser = useSelector((store) => store.user)
  const [value, setValue] = React.useState('1')
  const [comemntList, setComemntList] = useState([])
  const [message, setMessage] = useState({})
  const [selectedMessage, setSelectedMessage] = useState(false)
  const [messageList, setMessageList] = useState([])
  const [tempMessageList, setTempMessageList] = useState([])
  const [inbox, setInbox] = useState(true)
  const [mOpen, setMOpen] = useState(false)
  const [inputValue, setInputValue] = useState('')
  const [searchParams, setSearchParams] = useSearchParams()

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }
  useEffect(() => {
    getMessages()
  }, [])

  useEffect(() => {
    if (selectedMessage?.id) {
      setValue('1')
      getMessageCommints(selectedMessage.id)
    }
  }, [selectedMessage])
  useEffect(() => {
    if (searchParams.has('m') && searchParams.get('m')) {
      if (parseInt(searchParams.get('m'))) {
        // setSelectedMessage()
        console.log(searchParams.get('m'))
        if (messageList.inbox) {
          let inb = messageList.inbox.find((e) => e.id === parseInt(searchParams.get('m')))
          let outb = messageList.outbox.find((e) => e.id === parseInt(searchParams.get('m')))
          if (inb) {
            setSelectedMessage(inb)
            setTempMessageList(messageList.inbox)
          }
          if (outb) {
            setTempMessageList(messageList.outbox)
            setSelectedMessage(outb)
          }
        }
      }
    }
  }, [messageList])
  const handelInbox = (v) => {
    setValue('1')
    setInbox(v)
    if (v) {
      setTempMessageList(messageList.inbox)
    } else {
      setTempMessageList(messageList.outbox)
    }
  }
  const getMessages = async () => {
    const res = await makeGetRequest('/api/inbox/messages/', {}, true)
    if (res.status === 200) {
      setTempMessageList(res.data.inbox)
      setMessageList(res.data)
    }
  }
  const getMessageCommints = async (id) => {
    const res = await makeGetRequest(`/api/inbox/message/comments/${id}/`, {}, true)
    if (res.status === 200) {
      setComemntList(res.data)
    }
  }
  const submitComment = async (data1) => {
    let payload = {}
    payload = {
      content: inputValue,
      message_id: selectedMessage.id,
    }
    const { data, status } = await makePostRequest('/api/inbox/message/comment/', payload, {}, true)
    if (status === 200) {
      setComemntList((pre) => [...pre, data])
      setInputValue('')
    }
    // }
    // props.handleModelClose()
  }
  const infoTab = (
    <Box>
      <Box>{selectedMessage.content}</Box>
      {selectedMessage.message_obj && (
        <Box
          mt={3}
          sx={{ '& span': { color: 'gray', mr: 1, fontWeight: '400' }, fontWeight: '500' }}
        >
          {selectedMessage.message_object.field1 && (
            <Box>
              <span>{selectedMessage.message_object.field1}</span>
              {selectedMessage.message_object.value1}
            </Box>
          )}
          {selectedMessage.message_object.field2 && (
            <Box>
              <span>{selectedMessage.message_object.field2}</span>
              {selectedMessage.message_object.value2}
            </Box>
          )}
          {selectedMessage.message_object.field3 && (
            <Box>
              <span>{selectedMessage.message_object.field3}</span>
              {selectedMessage.message_object.value3}
            </Box>
          )}
          {selectedMessage.message_object.field4 && (
            <Box>
              <span>{selectedMessage.message_object.field4}</span>
              {selectedMessage.message_object.value4}
            </Box>
          )}
          {selectedMessage.message_object.field5 && (
            <Box>
              <span>{selectedMessage.message_object.field5}</span>
              {selectedMessage.message_object.value5}
            </Box>
          )}
          {selectedMessage.message_object.field6 && (
            <Box>
              <span>{selectedMessage.message_object.field6}</span>
              {selectedMessage.message_object.value6}
            </Box>
          )}
          {selectedMessage.message_object.field7 && (
            <Box>
              <span>{selectedMessage.message_object.field7}</span>
              {selectedMessage.message_object.value7}
            </Box>
          )}
          {selectedMessage.message_object.field8 && (
            <Box>
              <span>{selectedMessage.message_object.field8}</span>
              {selectedMessage.message_object.value8}
            </Box>
          )}
          {selectedMessage.message_object.field9 && (
            <Box>
              <span>{selectedMessage.message_object.field9}</span>
              {selectedMessage.message_object.value9}
            </Box>
          )}
          {selectedMessage.message_object.field10 && (
            <Box>
              <span>{selectedMessage.message_object.field10}</span>
              {selectedMessage.message_object.value10}
            </Box>
          )}
        </Box>
      )}
      {selectedMessage?.message_obj_list?.map((obj, index) => (
        <Box
          key={index}
          mt={3}
          sx={{ '& span': { color: 'gray', mr: 1, fontWeight: '400' }, fontWeight: '500' }}
        >
          {obj.field1 && (
            <Box>
              <span>{obj.field1}</span>
              {obj.value1}
            </Box>
          )}
          {obj.field2 && (
            <Box>
              <span>{obj.field2}</span>
              {obj.value2}
            </Box>
          )}
          {obj.field3 && (
            <Box>
              <span>{obj.field3}</span>
              {obj.value3}
            </Box>
          )}
          {obj.field4 && (
            <Box>
              <span>{obj.field4}</span>
              {obj.value4}
            </Box>
          )}
          {obj.field5 && (
            <Box>
              <span>{obj.field5}</span>
              {obj.value5}
            </Box>
          )}
          {obj.field6 && (
            <Box>
              <span>{obj.field6}</span>
              {obj.value6}
            </Box>
          )}
          {obj.field7 && (
            <Box>
              <span>{obj.field7}</span>
              {obj.value7}
            </Box>
          )}
          {obj.field8 && (
            <Box>
              <span>{obj.field8}</span>
              {obj.value8}
            </Box>
          )}
          {obj.field9 && (
            <Box>
              <span>{obj.field9}</span>
              {obj.value9}
            </Box>
          )}
          {obj.field10 && (
            <Box>
              <span>{obj.field10}</span>
              {obj.value10}
            </Box>
          )}
        </Box>
      ))}
    </Box>
  )

  const commentTab = (
    <Box bgcolor={'white'} borderRadius={'10px'}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          padding: '5px 0',
        }}
      >
        <Box
          sx={{
            padding: '0 5px',
          }}
        >
          <img alt="" src={CommentPng} />
        </Box>
        <Box>
          <Typography
            id="modal-modal-title"
            sx={{
              color: 'black !important',
              textAlign: 'left',
            }}
            variant="h7"
            component="h4"
          >
            {t('inbox.comments', 'Commentaires')}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ color: 'white' }}>
        <TableContainer>
          <Table sx={{ marginTop: '4px' }} size="small" aria-label="simple table">
            <TableBody>
              {comemntList?.map((row) => (
                <TableRow
                  key={row.id}
                  sx={{
                    height: '40px',
                    '&:last-child td, &:last-child th': { border: 0 },
                  }}
                >
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{ display: 'flex', alignItems: 'center' }}
                  >
                    {/* <AttachmentIcon sx={{ padding: '0px 13px', fontSize: '45px' }} /> */}
                    {row.user && row.comment_user.img ? (
                      <Avatar alt={'Life'} src={row.comment_user.img_url} />
                    ) : (
                      <Avatar alt={'Life'} src={''} />
                    )}
                    <Box sx={{ ml: 2 }}>
                      <Box component={'span'} sx={{ color: '#1779cd' }}>
                        {row.user && row.comment_user.prenom} {row.user && row.comment_user.nom}
                      </Box>
                      <br />
                      {row.content}
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { sm: '0.5fr 10fr' },
          padding: '0 10px',
          ml: 1,
          mt: 3,
        }}
      >
        {siteUser.user?.img ? (
          <Avatar alt={'Life'} src={siteUser.user.img_url} />
        ) : (
          <Avatar alt={'Life'} src={''} />
        )}
        <textarea
          rows={5}
          onChange={(e) => {
            setInputValue(e.target.value)
          }}
          value={inputValue}
        ></textarea>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'start' }} pb={5}>
        <Button variant="outlined" sx={{ ml: 10, mt: 2, fontSize: 16 }} onClick={submitComment}>
          {t('inbox.validate', 'Valider')}
        </Button>
      </Box>
    </Box>
  )
  return (
    <>
      {mOpen && <CreateMessage setMOpen={setMOpen} updateData={getMessages} />}
      <Box color={'white'} sx={{ flexGrow: 1, overflow: 'hidden', height: 'calc(100vh - 80px)' }}>
        <Grid container spacing={1} columns={16} height={'100%'}>
          <Grid item xs={3} display={'flex'} flexDirection={'column'} height={'100%'}>
            <Box display={'flex'} alignItems={'center'} px={2}>
              <Box fontSize={17} fontWeight={'bold'}>
                {t('inbox.allReceivedMail', {
                  count: tempMessageList?.length ?? 0,
                  defaultValue: 'Tous les courriers reçus ({{count}})',
                })}
              </Box>
              <Box ml={'auto'} sx={{ cursor: 'pointer' }} onClick={() => handelInbox(true)}>
                <img src={mailicon} style={{ height: 30 }} />
              </Box>
              <Box ml={1} sx={{ cursor: 'pointer' }} onClick={() => handelInbox(false)}>
                <SendIcon />
              </Box>
            </Box>
            <Box px={2} mt={2} position={'relative'}>
              <input
                style={{ width: '100%', borderRadius: '10px', padding: '5px 10px' }}
                placeholder={t('inbox.searchPlaceholder', 'Rechercher')}
              />
              <SearchIcon sx={{ position: 'absolute', right: 20, top: 8, color: 'black' }} />
            </Box>
            <Box
              mt={2}
              sx={{ overflowY: 'auto', height: '100%', display: 'flex', flexDirection: 'column' }}
            >
              {tempMessageList?.length === 0 && (
                <Box px={2} textAlign={'center'}>
                  {t('inbox.noItemsAvailable', 'Aucun élément disponible actuellement.')}{' '}
                </Box>
              )}
              {tempMessageList?.map((msg, index) => (
                <Box
                  onClick={() => setSelectedMessage(msg)}
                  key={index}
                  position={'relative'}
                  sx={{
                    height: 100,
                    minHeight: 100,
                    borderBottom: '1px solid gray',
                    padding: '10px 19px',
                    ':hover': {
                      bgcolor: '#296087',
                      borderRadius: '10px',
                      cursor: 'pointer',
                    },
                  }}
                >
                  <Box display={'flex'} alignItems={'center'}>
                    <Box sx={{ fontSize: 20, fontWeight: 'bold' }}>
                      {msg.message_object?.default_subject || msg.subject}
                    </Box>
                    {msg.message_object?.is_important && (
                      <Box ml={'auto'} color={'red'}>
                        {t('inbox.important', 'Important')}
                      </Box>
                    )}
                  </Box>
                  <Box>
                    {inbox ? (
                      <>
                        {msg.u_sender.prenom} {msg.u_sender.nom}
                      </>
                    ) : (
                      <>
                        {msg.u_recipient.prenom} {msg.u_recipient.nom}
                      </>
                    )}
                  </Box>
                  <Box position={'absolute'} sx={{ right: 19, bottom: 5, color: 'gray' }}>
                    {msg.status}
                  </Box>
                </Box>
              ))}
            </Box>
          </Grid>
          <Grid
            item
            xl={13}
            height={'100%'}
            display={'flex'}
            flexDirection={'column'}
            position={'relative'}
          >
            <Box
              position={'absolute'}
              top={5}
              right={15}
              sx={{ cursor: 'pointer', zIndex: 2 }}
              onClick={() => {
                setMOpen(true)
              }}
            >
              <AddIcon sx={{ fontSize: 35, cursor: 'pointer' }} />
            </Box>
            {selectedMessage ? (
              <>
                <Box textAlign={'center'}>
                  <Box fontSize={20} fontWeight={700}>
                    {selectedMessage.message_object?.default_subject || selectedMessage.subject}
                  </Box>
                </Box>
                <Box
                  px={3}
                  mt={4}
                  display={'flex'}
                  flexDirection={'column'}
                  height={'100%'}
                  overflow={'hidden'}
                >
                  <Box fontSize={18} fontWeight={700}>
                    {selectedMessage.subject}
                  </Box>
                  <Box display={'flex'} alignItems={'center'} mb={3}>
                    <Box>
                      {inbox ? (
                        <>
                          {selectedMessage.u_sender.prenom} {selectedMessage.u_sender.nom}
                        </>
                      ) : (
                        <>
                          {selectedMessage.u_recipient.prenom} {selectedMessage.u_recipient.nom}
                        </>
                      )}
                    </Box>
                    {selectedMessage.message_object?.is_important && (
                      <Box ml={'auto'} color={'red'}>
                        {t('inbox.important', 'Important')}
                      </Box>
                    )}
                  </Box>
                  {selectedMessage.message_obj && (
                    <Box>
                      {t('inbox.respondBefore', 'Répondre avant le :')}{' '}
                      {moment(selectedMessage.timestamp)
                        .add(selectedMessage.message_object?.default_due_date, 'days')
                        .format('YYYY-MM-DD')}
                    </Box>
                  )}
                  <Box>
                    {t('inbox.receivedOn', 'Reçu le :')}{' '}
                    {moment(selectedMessage.timestamp).format('YYYY-MM-DD')}
                  </Box>
                  <Box mt={2} height={'100%'} overflow={'hidden'}>
                    <Box
                      sx={{ width: '100%', typography: 'body1', height: '100%' }}
                      display={'flex'}
                      position={'relative'}
                      flexDirection={'column'}
                    >
                      <TabContext value={value}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                          <TabList
                            onChange={handleChange}
                            sx={{
                              '.MuiTabs-flexContainer': { justifyContent: 'flex-start' },
                            }}
                          >
                            <Tab
                              icon={<img src={infoicon} alt="" style={{ height: 60 }} />}
                              value="1"
                            />
                            <Tab
                              icon={<img src={attachementicon} alt="" style={{ height: 60 }} />}
                              value="2"
                            />
                            <Tab
                              icon={<img src={commenticon} alt="" style={{ height: 55 }} />}
                              value="3"
                            />
                          </TabList>
                        </Box>
                        <TabPanel value="1" sx={{ overflowY: 'auto' }}>
                          {infoTab}
                        </TabPanel>
                        <TabPanel value="2" sx={{ overflowY: 'auto' }}>
                          <BasicTableOfDoc mid={selectedMessage.id} />
                        </TabPanel>
                        <TabPanel value="3" sx={{ overflowY: 'auto' }}>
                          {commentTab}
                        </TabPanel>
                      </TabContext>
                      <Box position={'absolute'} bottom={30} right={40}>
                        <Button variant="contained" color="success" sx={{ px: 5 }}>
                          {t('inbox.accept', 'Accepter')}
                        </Button>
                        <Button variant="contained" color="error" sx={{ px: 5, ml: 5 }}>
                          {t('inbox.reject', 'Rejeter')}
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </>
            ) : (
              <Box
                sx={{
                  position: 'relative',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                }}
              >
                <Box sx={{ fontSize: 20, fontWeight: 700 }}>
                  {t('inbox.noDetailsAvailable', 'Aucun détail n’est actuellement disponible.')}{' '}
                </Box>
                <Box position={'absolute'} right={0} bottom={0} display={'flex'}>
                  <img src={blogo} alt="" style={{ height: 300 }} />
                </Box>
              </Box>
            )}
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

function BasicTableOfDoc({ mid }) {
  console.log(mid)
  const { t } = useTranslation()
  const siteUser = useSelector((store) => store.user)

  let params = useParams()
  const [selected, setSelected] = React.useState([])
  const [rowsPerPage, setRowsPerPage] = React.useState(20)
  const [newRows, setNewRows] = useState([])

  useEffect(() => {
    fetchOperations(params.id, 20)
  }, [mid])
  const fetchOperations = async (id, limit) => {
    const { data, status } = await makeGetRequest(
      // `/api/Administrative/documents-operations/?Vehicledata=${id}`,
      `/api/inbox/message/attatchment/${mid}/`,
      {},
      true,
    )
    if (status === 200) {
      let results = data
      setNewRows(results)
    }
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(rowsPerPage + 20)
    fetchOperations(params.id, rowsPerPage + 20)
  }
  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name)
    let newSelected = []
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1))
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1))
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      )
    }

    setSelected(newSelected)
  }
  const deleteBulkOperations = async () => {
    if (selected.length === 0) {
      alert(t('inbox.selectOperation', 'Sélectionner une opération'))
    } else {
      const response = await makePostRequest(
        urls.deleteDocumentsBulkOperations,
        { selected: selected },
        {},
        true,
      )
      if (response.status === 200) {
        fetchOperations(params.id, 20)
        setSelected([])
      }
    }
  }

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }} pb={5}>
        <Box>
          <Typography variant="h5" pl={1} sx={{ color: 'white' }}>
            {t('inbox.documentsCount', {
              count: newRows.length,
              defaultValue: 'Documents ({{count}})',
            })}
          </Typography>
        </Box>
        <Box>
          <CreateDocForm mid={mid} setNewRows={setNewRows} />
          {/* <CustomButton onClick={deleteBulkOperations}>Supprimer</CustomButton> */}
        </Box>
      </Box>
      <Box sx={{ color: 'white', paddingBottom: '60px' }}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650, marginTop: '23px' }} size="small" aria-label="simple table">
            <TableBody>
              {newRows && newRows.length > 0 ? (
                newRows.map((row, index) => (
                  <TableRow
                    key={row.id}
                    sx={{ height: '80px', '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{ display: 'flex', alignItems: 'center' }}
                    >
                      {/* {row.Lien.split('/').pop()} */}
                      <Checkbox
                        onClick={(event) => handleClick(event, row.id)}
                        color="primary"
                        inputProps={{
                          'aria-labelledby': index,
                        }}
                      />
                      <AttachmentIcon sx={{ padding: '0px 13px', fontSize: '45px' }} />
                      <div>
                        <Link sx={{ fontSize: '16px' }} href={row.line}>
                          {row.line?.split('/').pop()}
                        </Link>
                        <br />
                        Date:{' '}
                        {convertToUserDateFormate(
                          siteUser.user,
                          moment(row.uploaded_at).format('YYYY-MM-DD'),
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3}>{t('inbox.noDataYet', 'No data yet.')}</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          {/* {newRows.length > 20 && newRows.results.length % 20 === 0 ? ( */}
          {newRows?.length > 20 ? (
            <Box display={'flex'} justifyContent={'center'}>
              <Button onClick={handleChangeRowsPerPage}>{t('inbox.loadMore', 'Load more')}</Button>
            </Box>
          ) : (
            newRows?.length > 20 && (
              <Box display={'flex'} justifyContent={'center'}>
                <Button
                  onClick={() => {
                    fetchOperations(params.id, 20)
                    setRowsPerPage(20)
                  }}
                >
                  {t('inbox.returnToInitialSize', 'Return to initial size')}
                </Button>
              </Box>
            )
          )}
        </TableContainer>
      </Box>
    </>
  )
}
